import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ApiUri, BaseApiUri, BaseRepository, HellpositoryConfig} from "hellpository";
import {PostPayloadInterface} from "../models/post-payload.interface";


@BaseApiUri('dashboard/staff/guest-diys')
@Injectable({
  providedIn: 'root'
})
export class GuestDiyRepository extends BaseRepository<PostPayloadInterface> {

  constructor(public httpClient: HttpClient, public hellpConfig: HellpositoryConfig) {
    super(httpClient, hellpConfig);
  }

  @ApiUri('/change-status-to-in-progress')
  inProgress(ids: number[]) {
    const payload: PostPayloadInterface = {
      attribute: ids,
      id: 0,
      type: ""
    }
    return super.patch(payload);
  }

  @ApiUri('/change-status-to-sent-out')
  sentOut(ids: number[]) {
    const payload: PostPayloadInterface = {
      attribute: ids,
      id: 0,
      type: ""
    }
    return super.patch(payload);
  }

}
